// different from PlanComponentCategory because they don't map to pages one-to-one /shrug
export enum PlanComponentPageKey {
  Scope1CutEnergyWaste = "scope1CutEnergyWaste",
  Scope1Electrify = "scope1Electrify",
  Scope1BuyClean = "scope1BuyClean",
  Scope1LessCommonSolutions = "scope1LessCommonSolutions",
  Scope2CutEnergyWaste = "scope2CutEnergyWaste",
  Scope2BuyClean = "scope2BuyClean",
}
